/* ============================================================
   METHODIST — Puente entre el quiz y la cuenta del cliente
   Archivo: assets/mtd-cuenta.js

   Qué hace, sin tocar el motor del quiz (metodo-quiz.js):

   1. Sesión iniciada: rellena el correo de la pantalla "Último paso"
      y la salta, para que nadie escriba un correo que la tienda ya
      conoce.
   2. Al terminar el diagnóstico agrega al cliente la etiqueta del set
      recomendado (por ejemplo quiz-set-transformacion-capilar) y
      quiz-completado. Esas etiquetas son las que escucha Shopify Flow
      para escribir el metafield custom.test_capilar.

   Necesita window.MTD_CLIENTE (lo imprime layout/theme.liquid).
   Si el quiz no está en la página, este archivo no hace nada.
   ============================================================ */

(function () {
  "use strict";

  if (window.__mtdCuentaCargado) return;
  window.__mtdCuentaCargado = true;

  var C = window.MTD_CLIENTE || {};
  var ESPERA_ETIQUETAS = 1600; // ms: deja terminar el envío que hace el propio quiz

  function raiz() {
    return document.querySelector("[data-mtd-quiz]");
  }

  function prefijo(r) {
    return (r && r.dataset.eventoPrefijo) || "methodist";
  }

  function slug(s) {
    return String(s || "")
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  /* "set-transformacion-capilar" y "Set | Transformación Capilar"
     terminan los dos en "transformacion-capilar", para que la etiqueta
     quede como quiz-set-transformacion-capilar y no duplicada. */
  function slugSet(valor) {
    return slug(valor).replace(/^set-/, "");
  }

  function unicos(lista) {
    return lista.filter(function (t, i) {
      return t && lista.indexOf(t) === i;
    });
  }

  function leerLead() {
    try {
      var raw = localStorage.getItem("mtd_quiz");
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function esReciente(lead) {
    if (!lead || !lead.fecha) return false;
    var t = Date.parse(lead.fecha);
    return !isNaN(t) && Date.now() - t < 15 * 60 * 1000;
  }

  function hayEnlaceCompartido() {
    try {
      return !!new URLSearchParams(location.search).get("dx");
    } catch (e) {
      return false;
    }
  }

  /* ---------- 1. Correo automático con sesión iniciada ---------- */

  function autocompletarCorreo() {
    if (!C.email) return;

    var aplicar = function () {
      var r = raiz();
      if (!r) return;
      var input = r.querySelector("#mtd-email");
      var enviar = r.querySelector("[data-send]");
      if (!input || !enviar || input.dataset.mtdAuto === "1") return;

      input.dataset.mtdAuto = "1";
      input.value = C.email;
      input.setAttribute("readonly", "readonly");

      var tel = r.querySelector("#mtd-tel");
      var pantalla = input.closest(".mail");

      // Si además se pide WhatsApp no se puede saltar la pantalla:
      // se deja el correo puesto y la persona escribe su número.
      if (tel) {
        if (pantalla && pantalla.querySelector(".field")) {
          var aviso = document.createElement("p");
          aviso.className = "legal";
          aviso.textContent = "Usamos el correo de tu cuenta: " + C.email;
          pantalla.insertBefore(aviso, pantalla.querySelector(".field").nextSibling);
        }
        tel.focus();
        return;
      }

      // Sin WhatsApp: se envía sola y la persona pasa directo al resultado.
      if (pantalla) pantalla.style.visibility = "hidden";
      setTimeout(function () {
        try {
          enviar.click();
        } catch (e) {}
        setTimeout(function () {
          if (pantalla && document.body.contains(pantalla)) pantalla.style.visibility = "";
        }, 800);
      }, 40);
    };

    var obs = new MutationObserver(aplicar);
    obs.observe(document.documentElement, { childList: true, subtree: true });
    aplicar();
  }

  /* ---------- 2. Etiqueta del set para Shopify Flow ---------- */

  function enviarEtiquetas(tags, email) {
    var r = raiz();
    if (!r || !email || !tags.length) return false;

    var form = r.querySelector(".mtd-oculto form");
    var sink = r.querySelector(".mtd-oculto iframe");
    if (!form || !sink) return false;

    var campoMail = form.querySelector("[data-mtd-email]");
    var campoTags = form.querySelector("[data-mtd-tags]");
    if (!campoMail || !campoTags) return false;

    campoMail.value = email;
    campoTags.value = tags.join(",");
    form.target = sink.getAttribute("name");

    try {
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
      return true;
    } catch (e) {
      console.warn("[Methodist cuenta] no se pudieron enviar las etiquetas", e);
      return false;
    }
  }

  function etiquetasBase(pre, detalle) {
    return [
      pre,
      pre + "-" + (detalle.eje || ""),
      pre + "-linea-" + (detalle.aroma || ""),
      pre + "-" + (detalle.tamano || "") + "ml"
    ];
  }

  function escucharFinal() {
    var r = raiz();
    if (!r) return;
    var pre = prefijo(r);
    var etiquetaBase = r.dataset.etiquetas || "quiz";
    var yaEnviado = false;

    document.addEventListener(pre + ":quiz_complete", function (ev) {
      if (yaEnviado) return;
      if (hayEnlaceCompartido()) return; // resultado abierto desde un enlace, no uno nuevo

      var detalle = ev.detail || {};
      var lead = leerLead();
      var fresco = esReciente(lead);
      var correo = (fresco && lead.email) || C.email || "";
      if (!correo) return; // invitado que prefirió no dejar su correo

      var handle = slugSet((fresco && lead.set_handle) || detalle.set);
      var tags = (fresco && lead.etiquetas) || etiquetasBase(etiquetaBase, detalle);

      tags = unicos(
        tags.concat([etiquetaBase + "-set-" + handle, etiquetaBase + "-completado"])
      );

      yaEnviado = true;
      setTimeout(function () {
        enviarEtiquetas(tags, correo);
      }, ESPERA_ETIQUETAS);

      // Respaldo local para la tarjeta de /pages/mi-diagnostico mientras
      // Shopify Flow termina de escribir el metafield.
      try {
        localStorage.setItem(
          "mtd_dx_set",
          JSON.stringify({ set: detalle.set || "", handle: handle, fecha: new Date().toISOString() })
        );
      } catch (e) {}
    });
  }

  function iniciar() {
    var r = raiz();
    if (!r || r.dataset.mtdCuenta === "1") return;
    r.dataset.mtdCuenta = "1";
    autocompletarCorreo();
    escucharFinal();
  }

  document.addEventListener("DOMContentLoaded", iniciar);
  document.addEventListener("shopify:section:load", iniciar);
  iniciar();
})();
